import { render } from "./cronologiaScadenze.vue?vue&type=template&id=8e383a4a&ts=true"
import script from "./cronologiaScadenze.vue?vue&type=script&lang=ts"
export * from "./cronologiaScadenze.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__